import { Component, HostListener, OnInit } from '@angular/core';
declare var $:any;
@Component({
  selector: 'app-ct-three-three-one',
  templateUrl: './ct-three-three-one.component.html',
  styleUrls: ['./ct-three-three-one.component.scss']
})
export class CtThreeThreeOneComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  pdfSrc: string[] = [
    'https://gnkc.ac.in/assets/pdf/NAAC/DVV/3.3.1-No.-of-Research_Papers_5-Year_TEMPLATE.pdf',];
  src: string;

  showPdf = false;
  isLoading = true;
  showSideMenu = true;
  fullWidth = false;
  ngOnInit(): void {
    // this.changeRoute('1');
  }

  changeRoute(id: string) {
    this.isLoading = true;
    if (id === '1') {
      $(`one`).addClass('show');
      this.showPdf= true;
      this.src = this.pdfSrc[0];
    }
    if (id === '2') {
      $(`one`).removeClass('show');
      this.showPdf= false;
      // this.src = this.pdfSrc[0];
    }
  }
  hideLoader() {
    this.isLoading = false;
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 5){
      this.showSideMenu=true;
      this.fullWidth=false;
      // this.showHeading = true;
    }
    // else if(url.length === 5){
    //   this.showSideMenu=true;
    //   this.fullWidth=true;
    //   // this.showHeading = false;
    // }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
